export const getExtension = (_nameFile) => {
    const extension = _nameFile.slice((_nameFile.lastIndexOf(".")) + 1);
    return extension === _nameFile ? "" : extension;
}